export const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary(...args: any[]): void;
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
        <h2 className="text-2xl font-bold text-500 mb-2" style={{color: "#2de1fc"}}>
          Oops, something went wrong!
        </h2>
        <p className="text-gray-700 mb-4">
          We're experiencing a temporary issue. Please try again later.
        </p>
        <button
          className="bg-primary text-white px-4 py-2 rounded hover:text-600 transition"
          onClick={resetErrorBoundary}
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
};
